var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InputField',{staticClass:"u-mr-2",attrs:{"label":_vm.t('Shared.LineItemB2B.LineReference'),"maxlength":25,"value":_vm.reference},on:{"input":_setup.updateReference}})
}
var staticRenderFns = []

export { render, staticRenderFns }